module.exports = __webpack_public_path__ + "static/desktop-index-d118f546d8e2df8e9cf4819173093448.png";